// @ts-strict-ignore
/**
 * @owner @Appboy/clip
 * @fileoverview GET handler for the "/analytics_dashboard/:app_group_id/banners_credit_consumption_detail_data" endpoint
 */
import { isBannersConsumptionResult } from "@dashboardApi/apis/bannersConsumption/validators";

import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { bannersConsumption } from "./constants";
import type { BannersConsumptionParams, BannersConsumptionResult } from "./types";

export const getDataTableBannersConsumption = reactQueryTableFetcherAdapter(
  bannersConsumption,
  (
    signal: AbortSignal,
    { appGroupId, query, groupby, limit = 20, sortby, sortdir, start = 0 }: BannersConsumptionParams
  ): Promise<BannersConsumptionResult> => {
    const { start_date, end_date, app_group: appGroup } = query;

    return fetch(
      `/analytics_dashboard/${appGroupId}/banners_credit_consumption_detail_data`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        start_date: start_date,
        end_date: end_date,
        query: serializeQueryObjects({
          ...(appGroup && { app_group: appGroup }),
        }),
      },
      { signal }
    );
  },
  isBannersConsumptionResult
);
